import { GridApi, IRowNode } from 'ag-grid-community';

export const loadAllBlocks = (api: GridApi) => {
  const total = api.getDisplayedRowCount();
  const perPage = 100; // default block size
  let rowPointer = 0;

  while (rowPointer < total) {
    rowPointer += perPage;
    const rowToShow = Math.min(rowPointer, total);
    setTimeout(() => api.ensureIndexVisible(rowToShow - 1), 0);
  }

  setTimeout(() => api.ensureIndexVisible(0), 200);
};

export const areAllBlocksLoaded = (api: GridApi) => {
  // In AG Grid 34+, we check if all rows are loaded by comparing displayed count
  const displayedRowCount = api.getDisplayedRowCount();
  if (displayedRowCount === 0) {
    return false;
  }

  // Check if any rows are still loading (stub nodes)
  let hasStubNodes = false;
  api.forEachNode((node: IRowNode) => {
    if (node.stub) {
      hasStubNodes = true;
    }
  });

  return !hasStubNodes;
};

export const getLoadedNodes = (api: GridApi): IRowNode[] => {
  const selection: IRowNode[] = [];
  api.forEachNode((node: IRowNode) => selection.push(node));

  return selection;
};

export const getLoadedRows = <T>(api: GridApi): T[] => {
  return getLoadedNodes(api).map((node) => node.data);
};

// The `selectAll` method don't work for server side model.
// On the other hand `node.setSelected` takes too many time
// because of special cases and events dispatching. That's why
// here we are selecting all nodes using low level interface
// and we dispatch the EVENT_SELECTION_CHANGED only once.
export const setFastAllSelection = (api: GridApi, value: boolean) => {
  api.forEachNode((node: IRowNode) => {
    if (node.selectable) {
      node.setSelected(value, false, 'api');
    }
  });

  // Selection events are triggered automatically by setSelected calls
};

export const getSelectionStatus = (api: GridApi) => {
  const selectableNodes = getLoadedNodes(api).filter((node) => node.selectable && !node.stub);

  const selectableRowsCount = selectableNodes.length;
  // During server-side filtering / grid updates AG Grid can temporarily return undefined.
  // Treat it as "no selection" to avoid crashing header checkbox syncing.
  const selectedNodes = api.getSelectedNodes?.() ?? [];
  const selectedCount = selectedNodes.length;

  return { selectableRowsCount, selectedCount };
};
